<template>
    <div class="autocomplete">
        <label v-if="showLabel">Tiers</label>
        <b-form-input
            ref="searchInput"
            v-model="search"
            type="text"
            placeholder="Saisissez le nom du tiers recherché"
            :size="size"
            :state="validationState"
            @update="onChange"
        />
        <ul
            v-show="isOpen"
            id="autocomplete-results"
            class="autocomplete-results"
        >
            <li v-if="isLoading" class="loading">
                <i class="fas fa-spinner" spin></i>
                Recherche en cours
            </li>
            <li
                v-for="(client, i) in clients"
                v-if="!isLoading"
                :key="i"
                class="autocomplete-result"
                :class="{ 'is-active': i === arrowCounter }"
                @click="setClient(client)"
            >
                {{ clientDetails(client) }}
            </li>
        </ul>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
    name: 'SearchClient',

    props: {
        size: '',
        showLabel: true,
        clientRequired: true,
        // search endpoint, the search text is appended
        // (time sheets: /time-sheets/tiers-search or /clients/search-with-prospects)
        searchUrl: {
            type: String,
            default: '/clients/search',
        },
    },

    data() {
        return {
            isOpen: false,
            clients: [],
            clientId: '',
            search: '',
            isLoading: false,
            arrowCounter: 0,
            hasResult: false,
            ErrorFeedback: {
                required: 'Champ obligatoire',
            },
        }
    },

    validations: {
        search: {
            required,
        },
    },

    computed: {
        noResult() {
            return this.clients.length === 0
        },

        validationState() {
            return this.clientRequired === false
                ? true
                : !this.$v.search.$invalid
        },
    },

    methods: {
        onChange() {
            this.resetClient()
            this.getClients()
            this.$emit('searching-client')
        },

        async getClients() {
            if (this.search.length >= 2) {
                try {
                    this.hasResult = false
                    this.isOpen = true
                    this.isLoading = true
                    const response = await axios.get(
                        `${this.searchUrl}/${encodeURIComponent(this.search)}`
                    )
                    this.clients = response.data.data
                    this.isLoading = false
                } catch (error) {
                    // handle error
                    console.log(error)
                }
            } else {
                this.clients = []
            }
            this.checkResults()
        },

        clientDetails(client) {
            return client.is_prospect
                ? `${client.name} (prospect)`
                : client.name
        },

        setClient(client) {
            this.search = this.clientDetails(client)
            this.$emit('client-is-set', client)
            this.isOpen = false
            this.hasResult = true
        },

        resetClient() {
            this.$emit('client-is-not-set')
        },

        checkResults() {
            if (this.noResult) {
                this.isOpen = false
            }
        },
    },
}
</script>

<style scoped>
.autocomplete {
    position: relative;
}

.autocomplete-results {
    padding: 0;
    margin: 0;
    border: 1px solid #eeeeee;
    height: 150px;
    overflow: auto;
    background-color: #fff;
}

.autocomplete-result {
    font-size: 12px;
    list-style: none;
    text-align: left;
    padding: 4px 12px;
    cursor: pointer;
}

.autocomplete-result:hover {
    background-color: #98be12;
    color: #ffffff;
}

.loading {
    list-style: none;
    text-align: center;
    padding: 0;
    cursor: none;
    margin-top: 20px;
}
</style>
